import React, {lazy} from "react"
import ToggleSwitch, {TextOptionElem} from "../../../../common/ToggleSwitch.jsx";
import MapboxHelpTooltip from "./MapboxHelpTooltip.jsx";

const CodeEditor = lazy(() => import('@uiw/react-textarea-code-editor'));

const InputWithJson = ({
    withInput = false,
    jsonInputSetting = {},
    toggleSetting = {}
}) => {
    const {label, description, value, defaultJson, updateJsonValue} = jsonInputSetting;
    const {name, useJson, setUseJson} = toggleSetting;
    return withInput ? 
        <>
            <label className="col-xs-9 col-md-9" style={{display: useJson ? 'block' : 'none'}}>

                <div style={{display: useJson ? 'block' : 'none'}}>
                    {label}
                    <MapboxHelpTooltip description={description}/>
                    <CodeEditor
                        value={value || defaultJson}
                        language="json"
                        placeholder={I18n.t('enter_formula_placeholder')}
                        onChange={(e) => updateJsonValue(e.target.value)}
                        data-color-mode="light"
                        style={{
                            fontSize: 12,
                            fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                            maxWidth: '800px',
                            minWidth: '200px'
                        }}
                    />
                </div>
            </label>

            <label className="col-xs-3 col-md-3 d-flex pt-2 align-items-center">
                <label>{I18n.t("input_json")}</label>
                <MapboxHelpTooltip description={I18n.t('input_json_description')} className='mr-1' />
                <ToggleSwitch 
                    isOn={useJson}
                    name={name}
                    handleToggle={(e) => setUseJson(!useJson)}
                    yesElem={<TextOptionElem side='left' text={I18n.t('option_yes')} />}
                    noElem={<TextOptionElem side='right' text={I18n.t('option_no')} />}
                />
            </label>
        </>
        :
        <label className='col-xs-12 col-md-12'>
            {label}
            <MapboxHelpTooltip description={description}/>
            <CodeEditor
                value={value}
                language="json"
                placeholder={I18n.t('enter_formula_placeholder')}
                onChange={(e) => updateJsonValue(e.target.value)}
                data-color-mode="light"
                style={{
                    fontSize: 12,
                    fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                    maxWidth: '800px',
                    minWidth: '200px'
                }}
            />
        </label>
}

export default InputWithJson